import FlexBox from '@/atomic-components/FlexBox';
import { Box, Drawer, Typography } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CrossIcon from '../../../../assets/pdp/crossIcon.svg';
import { VASInformation, VASMapper, VAStileMapper } from '.';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import Stars from './stars';
import LencoButton from '@/atomic-components/LencoButton';
import { useEffect } from 'react';
import { emitMoeEvent } from '@/utils/dataLayer';

type VasDrawerProps = {
	vas: VASInformation;
	open: boolean;
	closeDrawer: () => void;
};

export const VasNames={
	FURLENCO_CARE_PROGRAM : "Care Program",
	FLEXI_CANCELLATION: "Flexi Cancellation"
}

const VasDrawer = (props: VasDrawerProps) => {
	const { vas } = props;

	useEffect(() => {
		if (props.open) {
			emitMoeEvent('Info Bottomsheet Opened', {
				heading: 'VAS Info',
			});
		}
	}, [props.open]);

	const VasTileStyle = VASMapper[vas.type as keyof VAStileMapper];
	return (
		<Drawer
			anchor='right'
			open={props.open}
			onClose={() => props.closeDrawer()}
		>
			<Box sx={{ width: '620px', padding: '80px' }}>
				<FlexBox sx={{ justifyContent: 'end', paddingBottom: '50px' }}>
					<Box sx={{ cursor: 'pointer' }} onClick={() => props.closeDrawer()}>
						<CrossIcon />
					</Box>
				</FlexBox>

				<Box
					sx={{
						background: `${VasTileStyle.background}`,
						padding: '32px',
						borderRadius: '32px',
						position: 'relative',
					}}
				>
					<Box
						sx={{
							position: 'absolute',
							top: 0,
							left: 4,
							overflow: 'hidden',
						}}
					>
						<Stars color={getColor(`${VasTileStyle.starColor}`)} />
					</Box>
					<FlexBox sx={{ justifyContent: 'start', mb: '16px' }}>
						<Box sx={{ paddingRight: '8px' }}>{VasTileStyle.icon}</Box>
						<Box sx={{ width: '100%' }}>
							<LencoTypography
								sx={{
									...getStyle('H5A_Medium'),
									color: getColor('Gray 0'),
								}}
							>
								{VasNames[vas?.type as keyof typeof VasNames] || vas?.name}
							</LencoTypography>
							<LencoTypography
								sx={{
									...getStyle('H14_Regular'),
									color: getColor('Gray -1'),
									marginBottom: '8px',
								}}
							>
								{vas?.startingAtText}
							</LencoTypography>
							<LencoTypography
								sx={{
									...getStyle('P_Regular'),
									color: getColor('Gray -2'),
								}}
								dangerouslySetInnerHTML={{
									__html: vas.description,
								}}
							></LencoTypography>
						</Box>
					</FlexBox>
				</Box>
				<Box
					sx={{
						width: '100%',
						height: '1px',
						background: getColor('Gray -5'),
						margin: '24px 0 40px 0',
					}}
				></Box>
				<Box sx={{ paddingLeft: '40px' }}>
					<LencoTypography
						sx={{
							...getStyle('H14_Medium'),
							color: getColor('Gray 0'),
							paddingBottom: '16px',
						}}
					>
						Terms and Conditions:
					</LencoTypography>
					<LencoTypography
						sx={{
							...getStyle('P_Regular'),
							color: getColor('Gray -2'),
							ul: { paddingLeft: '16px', lineHeight: 1.8 },
							paddingBottom: '20px',
						}}
						dangerouslySetInnerHTML={{
							__html: vas.termsAndConditions,
						}}
					></LencoTypography>
					<LencoButton
						variant='contained'
						sx={{
							border: '1px solid #777777',
							backgroundColor: '#FFFFFF',
							borderRadius: '100px',
							height: '48px',
							width: '200px',
							...getStyle('Small_SemiBold'),
							color: '#777777',
						}}
						onClick={() => props.closeDrawer()}
					>
						UNDERSTOOD
					</LencoButton>
				</Box>
			</Box>
		</Drawer>
	);
};

export default VasDrawer;
